import { motion } from "framer-motion";
import MotionDiv from "global/motions/MotionDiv";
import _ from 'lodash';
import React from 'react';
import { Icon, Label } from 'semantic-ui-react';

const MatchesViewer = ({ matches }) => {

  const matchViewer = () => {
    const _matches = _.map(matches, (match, matchKey) => {
      return <MatchView match={match} />
    })
    return <div className='mddd'>
      {_matches}
    </div>
  }

  return matchViewer()
}

export const MatchView = ({ match }) => {

  const div_matchItem = (cn, value, icon) => icon ? <div className={'m-' + cn}><Icon size='small' color='grey' className={'mi-' + cn} name={icon} /> {value}</div> : <div className={'m-' + cn}>{value}</div>

  const divs_match = (match) => {
    const divs = {
      keys: [],
      teams: [],
      results: [],
      ls: [],
      dates: [],
      location: [],
      other: []
    }

    let isBye = false;
    let isSeed = false;
    let hasResult = false;

    const { home, away, pending } = match

    _.forEach(match, (item, key) => {

      const { name: name_team, away: away_pending, home: home_pending, away: away_seed, home: home_seed, score } = item ?? {}

      isSeed = home_seed ? true : false

      switch (key) {
        case 'results':
          if (score) {
            hasResult = true
            divs.teams.push(div_matchItem('result-h', <Label size='tiny' circular color='green'>{score?.away}</Label>))
            divs.teams.push(div_matchItem('result-a', <Label size='tiny' circular color='green'>{score?.home}</Label>))
          }
          break;

        case '_matchCollectionKey':
          divs.keys.push(div_matchItem(key, _.startCase(item)))
          break;
        case 'pending':
          if (!away) {
            divs.teams.push(div_matchItem('away-p', away_pending?.poolName + ' ' + away_pending.matchNumber + '/' + away_pending.place))
          }
          if (!home) {
            divs.teams.push(div_matchItem('home-p', home_pending?.poolName + ' ' + home_pending.matchNumber + '/' + home_pending.place))
          }
          break;
        case 'away':
        case 'home':
          if (!_.isObject(name_team)) {
            divs.teams.push(div_matchItem(key, name_team))
            if (name_team === 'BYE') {
              isBye = true
            }
          }
          break;
        case 'startDate':
          divs.dates.push(div_matchItem(key, item, 'calendar outline'))
          break;
        case 'startTime':
          divs.dates.push(div_matchItem(key, item, 'clock outline'))
          break;
        case 'location':
          const { name: name_location } = item
          divs.location.push(div_matchItem(key, name_location, 'home'))
          break;
        case 'poolKey':
          divs.ls.push(div_matchItem(key, _.startCase(item), 'trophy'))
          break;
        case 'matchNumber':
          divs.ls.push(div_matchItem(key, item, 'hashtag'))
          break;
        case 'levels':
          divs.ls.push(div_matchItem(key, item))
          break;
        case 'seeds':
          divs.teams.push(div_matchItem('seed-home', <Label size='tiny' circular color='green'>{away_seed}</Label>))
          divs.teams.push(div_matchItem('seed-away', <Label size='tiny' circular color='green'>{home_seed}</Label>))
          break;
        case 'teams':
        case 'roundKey':
        case 'name':
        case 'matchKey':
        case 'isPlayoff':
        case 'sectionMeeting':
          break;
        default:
          divs.other.push(div_matchItem(key, item))
      }
    })

    let cn = 'matcher-list'
    let cnt = 'm-teams'
    if (isBye) { cn += ' bye' }
    if (isSeed) { cnt += ' seed' }
    if (hasResult) { cnt += ' rst' }
    return <div className={cn}>
      <div className='m-ls'>{divs.keys}</div>
      <div className={cnt}>{divs.teams}</div>
      <div className='m-dates'>{divs.dates}</div>
      <div className='m-locations'>{divs.location}</div>
    </div>
  }

  return <MotionDiv>
    {divs_match(match)}
  </MotionDiv>

}

export default MatchesViewer